import axios from 'axios';

import { currencyConstants } from '../constants';

export const currencyActions = {
    getCurrency,
    createCurrency,
    updateCurrency,
    deleteCurrency,
};

function getCurrency() {
    return async (dispatch, getState) => {
        if (getState.currency && getState().currency.currency) return;
        dispatch(request());

        try {
            const response = await axios.get('/currency');

            if (response.status === 200) dispatch(success(response.data));
            if (response.status === 500) dispatch(failure(response.data.toString()));
        } catch (error) {
            console.error(error);
            if (error.response) {
                dispatch(failure(error.response.data.toString()));
            } else {
                dispatch(failure('Unable to fetch currency structure at this moment. Please try again later.'));
            }
        }
    };

    function request() {
        return { type: currencyConstants.GET_CURRENCY_REQUEST };
    }
    function success(currency) {
        return { type: currencyConstants.GET_CURRENCY_SUCCESS, currency };
    }
    function failure(error) {
        return { type: currencyConstants.GET_CURRENCY_FAILURE, error };
    }
}

function createCurrency() {
    return async (dispatch) => {
        dispatch(request());

        try {
            const response = await axios.post('/currency');

            if (response.status === 201) dispatch(success(response.data));
            if (response.status === 500) dispatch(failure(response.data.toString()));
        } catch (error) {
            console.error(error);
            if (error.response) {
                dispatch(failure(error.response.data.toString()));
            } else {
                dispatch(failure('Unable to create currency at this moment. Please try again later.'));
            }
        }
    };

    function request() {
        return { type: currencyConstants.CREATE_CURRENCY_REQUEST };
    }
    function success(currency) {
        return { type: currencyConstants.CREATE_CURRENCY_SUCCES, currency };
    }
    function failure(error) {
        return { type: currencyConstants.CREATE_CURRENCY_FAILURE, error };
    }
}

function parseLocalizedNumber(value, notation = 'American') {
    if (typeof value === 'number') return value;
    if (typeof value !== 'string') return NaN;

    let normalized = value.trim();

    if (!normalized) return NaN;

    if (notation === 'European') {
        normalized = normalized.replace(/\./g, '').replace(',', '.');
    } else {
        normalized = normalized.replace(/,/g, '');
    }

    return Number(normalized);
}

export function updateCurrency(currency) {
    return async (dispatch, getState) => {
        dispatch(request());

        try {
            const notation =
                getState().organization?.organization?.notation || 'American';

            const period = Object.keys(currency.period)[0];
            let isCurrency = true;
            let updatedCurrency = {};
            let url = '/currency/';

            if (period === 'currency') {
                updatedCurrency = { currency: currency.currency };
                updatedCurrency.currency = currency.period.currency;
                url += currency.currency_id;

                delete updatedCurrency.currency_id;
            } else {
                const selectedPeriod = period.slice(6);

                currency.currency_period.forEach((currencyPeriod, index) => {
                    if (selectedPeriod === currencyPeriod.period) {
                        updatedCurrency = { ...currency.currency_period[index] };

                        const exchangeRate = parseLocalizedNumber(
                            currency.period[period],
                            notation
                        );

                        if (Number.isNaN(exchangeRate)) {
                            throw new Error('Invalid exchange rate');
                        }

                        updatedCurrency.exchange_rate = exchangeRate;
                        url += updatedCurrency.currency_period_id;

                        delete updatedCurrency.currency_id;
                        delete updatedCurrency.currency_period_id;
                    }
                });

                isCurrency = false;
            }

            const response = await axios.put(url, {
                currency: updatedCurrency,
                isCurrency,
            });

            if (response.status === 200) dispatch(success(response.data));
            if (response.status === 500) dispatch(failure(response.data.toString()));
        } catch (error) {
            console.error(error);

            if (error.response) {
                dispatch(failure(error.response.data.toString()));
            } else {
                dispatch(
                    failure(
                        error.message ||
                            'Unable to update currency at this moment. Please try again later.'
                    )
                );
            }
        }
    };

    function request() {
        return { type: currencyConstants.UPDATE_CURRENCY_REQUEST };
    }

    function success(currency) {
        return { type: currencyConstants.UPDATE_CURRENCY_SUCCESS, currency };
    }

    function failure(error) {
        return { type: currencyConstants.UPDATE_CURRENCY_FAILURE, error };
    }
}
function deleteCurrency(currency) {
    return async (dispatch) => {
        dispatch(request());

        try {
            const url = '/currency/' + currency.currency_id;
            const response = await axios.delete(url);

            if (response.status === 200) dispatch(success(response.data));
            if (response.status === 500) dispatch(failure(response.data.toString()));
        } catch (error) {
            console.error(error);
            if (error.response) {
                const data = error.response.data;

                // Handle the CURRENCY_IN_USE case specifically
                if (data?.error === 'CURRENCY_IN_USE') {
                    dispatch(blocked(data.scenarios));
                } else {
                    dispatch(failure(data.toString()));
                }
            } else {
                dispatch(failure('Unable to update currency at this moment. Please try again later.'));
            }
        }
    };

    function request() {
        return { type: currencyConstants.DELETE_CURRENCY_REQUEST };
    }
    function success(currency) {
        return { type: currencyConstants.DELETE_CURRENCY_SUCCESS, currency };
    }
    function failure(error) {
        return { type: currencyConstants.DELETE_CURRENCY_FAILURE, error };
    }
    function blocked(scenarios) {
        return { type: currencyConstants.DELETE_CURRENCY_BLOCKED, scenarios };
    }
}

export const loadCurrenciesForScenario = (scenarioId) => async (dispatch) => {
  dispatch({ type: currencyConstants.LOAD_CURRENCIES_REQUEST, scenarioId });

  try {
    const res = await axios.get(`/currencies/${scenarioId}`);
    
    dispatch({ type: currencyConstants.LOAD_CURRENCIES_SUCCESS, currencies: res.data });
    
    return res.data; 
  } 
  catch (err) {
    dispatch({ type: currencyConstants.LOAD_CURRENCIES_FAILURE, error: err?.response?.data || String(err) });
    throw err;
  }
}
